import { render, staticRenderFns } from "./CustomFieldList.vue?vue&type=template&id=2412986a&"
import script from "./CustomFieldList.vue?vue&type=script&lang=js&"
export * from "./CustomFieldList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports